import styled from "styled-components";

import CheckboxStyle from '@material-ui/core/Checkbox';
import FormControlStyle from '@material-ui/core/FormControl';
import FormControlLabelStyle from '@material-ui/core/FormControlLabel';
import FormHelperTextStyle from '@material-ui/core/FormHelperText';
import InputLabelStyle from '@material-ui/core/InputLabel';
import OutlinedInputStyle from '@material-ui/core/OutlinedInput';
import RadioGroupStyle from '@material-ui/core/RadioGroup';
import SelectStyle from '@material-ui/core/Select';
import TextFieldStyle from '@material-ui/core/TextField';
import { Wallet } from "config";


const pathname = "estadao_atendimento";
const currWallet = Wallet[pathname];

export const Checkbox = styled(CheckboxStyle)``
export const FormControlLabel = styled(FormControlLabelStyle)`
    && {
        span {
            font-size: 14px;
        }
    }
`
export const Container = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fb;
  padding: 20px;
  overflow-y: auto;
`

export const Waiting = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 'calc(300px + 150px)',

    'img': {
        width: '90px',
        height: '90px',
        margin: '0',
    },

    '.digitalk-waiting-text': {
        fontSize: '20px',
        fontWeight: 600,
    },

    '.digitalk-number': {
        fontSize: '65px',
        fontWeight: 700,
        margin: '10px 0',
        color: '#444444',
    },

    '.digitalk-waiting': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',

        'span': {
            fontSize: '14px',
        }
    },
}))

export const FormControl = styled(FormControlStyle)`
    && { 
        height: auto;
        min-height: 40px;
        margin: 0;
        &.phone {
            width: 50%;
        }
        &.select {
            height: fit-content;
            margin-top: 27px;
            label {
                left: -14px;
                top: -11px;
            }
        }
    }
`
export const Select = styled(SelectStyle)`
    && {
        >div {
            font-size: 14px;
            padding: 10px 14px;
        }
    }
`
export const InputLabel = styled(InputLabelStyle)`
    && {
        top: -18px;
    }
`
export const OutlinedInput = styled(OutlinedInputStyle)`
    && {
        min-height: 40px;
        input {
            font-size: 14px;
            padding: 12px 14px;
        }
    }
`
export const Form = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 450px;
    background: #fff;
    padding: 32px;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.05);
    
    &.form_container {
        >div {
           display: flex;
           flex-direction: column;
           gap: 16px;
        }
    }
    p {
        &.title {
            margin-bottom: 8px;
            font-size: 24px;
            color: ${({ theme }) => theme.palette.primary.main};
            padding: 0;
            font-weight: 600;
        }
        color: #666;
        font-weight: 500;
        margin: 0 0 24px;
    }
    .label {
        font-weight: bold;
        color: ${({ theme }) => theme.palette.primary.main};
    }
    >button {
        margin-top: 24px;
    }
`

export const Button = styled.button`
    cursor: pointer;
    font-weight: 500;
    padding: 3px 40px;
    font-size: 15px;
    border: solid 2px ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.primary.main};
    width: 100%;
    height: 45px;
    border-radius: 3px;
    background-color: transparent;
    &.confirm:not([disabled]){
        background-color: ${({ theme }) => theme.palette.primary.main};
        color: white;
    }
    &.back {
      width: fit-content;
      margin: 0 16px 22px;
      padding: 6px 12px;
      border-radius: 0;
      border: none;
      > svg {
          transform: rotate(270deg);
      }
    }

  &:disabled {
    color: #ceceec;
    border-color: #ceceec;
    cursor: not-allowed;
    &:hover {
        background: #fff;
        color: #ceceec; 
    }
  }
    >svg {
        height: 12px;
        margin-right: 5px;
    }
    &:hover {
        background-color: ${({ theme }) => theme.palette.primary.main};
        color: #fff;
    }
  
`


export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    padding: 0;
    width: 100%;
    margin-top: 8px;
`


export const Box = styled.div`
    font-size: 14px;
    background-color: #FFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 16px 0;
    >img {
        margin-bottom: 32px;
        height: 80px;
    }
    
    >p {
        margin: 0;
        &.title {
            color: ${({ theme }) => theme.palette.primary.main};
            font-weight: 600;
            margin-bottom: 8px;
            font-size: 20px;
        }
        &.confirm {
            color: #333333;
            margin-top: 16px;
        }
        width: 100%;
        color: #222;
        &+p{
            margin-top: 8px;
        }
      
    }
`

export const TextField = styled(TextFieldStyle)`

`
export const FormHelperText = styled(FormHelperTextStyle)`
    align-self: flex-end;
`
export const RadioGroup = styled(RadioGroupStyle)`
    && {
        row-gap: 4px;
        column-gap: 8px;
        margin-top: 6px;
        display: flex;
        flex-direction: column;
        label {
            margin-right: 0;
            margin-left: 0;
            .label_radio {
                font-size: 14px;
            }
            .radio {
                padding: 3px;
            }
        }
    }
`
export const InputGroup = styled(FormControlStyle)`
    && {
        display: flex;
        flex-direction: row;
        &.fieldset {
            background-color: #ffffff;
            legend {
                color: #333333;
                padding: 0 16px 9px;
            }
            >div {
                margin-top: 0;
                padding: 0 12px;
            }
        }
        &+&&{
            margin-top: 16px;
        }
        >* {
            flex: 3 0;
            &+*:not(${RadioGroup}) {
                margin-left: 0;    
            }
            &.small{
                flex: 1 0;
            } 
        }
    }
`